import Vue from 'vue'
import Router from 'vue-router'
import Redirect from '@/pages/Redirect'
import Login from '@/pages/Login'
import Index from '@/pages/Index'
import Mine from '@/pages/Mine'
import Admin from '@/pages/Admin'
import ReservationTips from '@/pages/ReservationTips'
import ReservationEdit from '@/pages/ReservationEdit'
import ReservationStatus from '@/pages/ReservationStatus'
import ReservationList from '@/pages/ReservationList'
import WriteOf from '@/pages/WriteOf'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'redirect',
      component: Redirect
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/index',
      name: 'index',
      component: Index
    },
    {
      path: '/mine',
      name: 'mine',
      component: Mine
    },
    {
      path: '/tips',
      name: 'tips',
      component: ReservationTips
    },
    {
      path: '/edit',
      name: 'edit',
      component: ReservationEdit
    },
    {
      path: '/status',
      name: 'status',
      component: ReservationStatus
    },
    {
      path: '/list',
      name: 'list',
      component: ReservationList
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '/writeof',
      name: 'writeof',
      component: WriteOf
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js